import React from 'react'
import CreateTransaction from '../../../Component/transaction/createTransaction'

const WithdrawTransaction = () => {
  return (
    <div>
        <CreateTransaction callingParrent = "Withdraw"/>
    </div>
  )
}

export default WithdrawTransaction